import { defineMessages } from 'react-intl'

export const deleteDomainMessages = defineMessages({
  ctaBtn: {
    id: 'deleteDomain.ctaBtn',
    description: 'CTA button text on modal allowing to delete  Group/Domain',
    defaultMessage: 'Yes, Delete',
  },
  cancelBtn: {
    id: 'deleteDomain.cancelBtn',
    description: 'Cancel button text on modal allowing to delete  Group/Domain',
    defaultMessage: 'No, Cancel',
  },
  title: {
    id: 'deleteDomain.title',
    description: 'A title of modal allowing to delete Group/Domain',
    defaultMessage: 'Delete group {domainName}',
  },
  confirmText: {
    id: 'deleteDomain.confirmText',
    description: 'Modal confirm text for deleting Group/Domain',
    defaultMessage:
      'Are you sure you want to delete group {domainName}?{br} All jobs/homes will be added to the group {parentDomainName}.',
  },
  hasNestedError: {
    id: 'deleteDomain.hasNestedError',
    description:
      'Text for error while trying to delete Group/Domain that has nested Groups/Domains',
    defaultMessage:
      'To delete this group you must first delete its nested groups',
  },
})
